import React from 'react';
import { FaMapMarkerAlt, FaBriefcase, FaUserTie, FaTasks, FaChartLine, FaLanguage, FaGraduationCap } from 'react-icons/fa';

const CareersPage = () => {
  return (
    <div className="font-sans text-gray-800 bg-gray-50">
      {/* Hero Section */}
      <section className="bg-[#5C4033] pt-28 text-white py-16 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-4">Join Our Team</h1>
          <p className="text-xl mb-8">Help build Digital India through innovative connectivity solutions</p>
          <div className="bg-white text-[#5C4033] inline-block px-4 py-2 rounded-lg font-medium">
            Current Opening: Marketing & Project Executive (Field)
          </div>
        </div>
      </section>

      {/* Job Overview Section */}
      <section className="py-12 px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
          <div className="p-8">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">Marketing & Project Executive (Field)</h2>
              <div className="mt-4 md:mt-0">
                <a 
                  href="https://forms.gle/mRiX7DJqu7tx4bdh9" 
                  className="bg-[#5C4033] hover:bg-[#4a3429] text-white font-bold py-3 px-6 rounded-lg transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Apply Now
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="flex items-center">
                <FaMapMarkerAlt className="text-[#5C4033] mr-3 text-xl" />
                <div>
                  <h3 className="font-semibold text-gray-700">Location</h3>
                  <p>Uttar Pradesh</p>
                </div>
              </div>
              <div className="flex items-center">
                <FaBriefcase className="text-[#5C4033] mr-3 text-xl" />
                <div>
                  <h3 className="font-semibold text-gray-700">Employment Type</h3>
                  <p>Full-Time</p>
                </div>
              </div>
              <div className="flex items-center">
                <FaUserTie className="text-[#5C4033] mr-3 text-xl" />
                <div>
                  <h3 className="font-semibold text-gray-700">Experience</h3>
                  <p>1–3 years (Freshers may apply)</p>
                </div>
              </div>
              <div className="flex items-center">
                <FaTasks className="text-[#5C4033] mr-3 text-xl" />
                <div>
                  <h3 className="font-semibold text-gray-700">Industry</h3>
                  <p>Digital Services, Telecom, Fintech, Wi-Fi Projects</p>
                </div>
              </div>
            </div>

            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">About the Role</h3>
              <p className="mb-4">
                We are seeking a dynamic and motivated Marketing & Project Executive (Field) to join our growing team. 
                The role involves on-ground execution of marketing campaigns, project implementation, and client engagement 
                for various digital and government-linked services such as PM-WANI Wi-Fi, white-label ATMs, CSP banking, 
                GPS tracking, and more.
              </p>
              <p>
                You will represent the company in the field, manage project roll-outs, onboard vendors/partners, and generate 
                leads by meeting clients, institutions, and local businesses. This is a performance-driven role for individuals 
                who enjoy fieldwork, building relationships, and delivering results.
              </p>
            </div>

            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Key Responsibilities</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Promote and explain company products/services to potential clients, vendors, and partners.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Implement on-site deployment of services such as Wi-Fi installations, ATM setups, and digital banking touchpoints.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Conduct field visits across designated regions (block, tehsil, district level).</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Meet daily/weekly targets for client acquisition and project completion.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Coordinate with the operations and technical teams for installation and support.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Prepare reports, feedback, and documentation on field activities.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Educate local users and partners about services like PM-WANI, white-label ATM withdrawals, GPS tracking, and digital tools.</span>
                </li>
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Key Skills</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-start">
                  <FaLanguage className="text-[#5C4033] mr-3 mt-1 flex-shrink-0" />
                  <span>Excellent communication and interpersonal skills (Hindi/regional language essential, English preferred)</span>
                </div>
                <div className="flex items-start">
                  <FaChartLine className="text-[#5C4033] mr-3 mt-1 flex-shrink-0" />
                  <span>Strong understanding of rural/urban markets</span>
                </div>
                <div className="flex items-start">
                  <FaUserTie className="text-[#5C4033] mr-3 mt-1 flex-shrink-0" />
                  <span>Self-motivated, proactive, and target-oriented</span>
                </div>
                <div className="flex items-start">
                  <FaBriefcase className="text-[#5C4033] mr-3 mt-1 flex-shrink-0" />
                  <span>Basic technical knowledge of internet, Wi-Fi, or financial products is a plus</span>
                </div>
                <div className="flex items-start">
                  <FaMapMarkerAlt className="text-[#5C4033] mr-3 mt-1 flex-shrink-0" />
                  <span>Willingness to travel extensively within assigned areas</span>
                </div>
              </div>
            </div>

            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Qualifications</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaGraduationCap className="text-[#5C4033] mr-3 mt-1 flex-shrink-0" />
                  <span>Bachelor's degree in Marketing, Business, or related field</span>
                </li>
                <li className="flex items-start">
                  <FaUserTie className="text-[#5C4033] mr-3 mt-1 flex-shrink-0" />
                  <span>Relevant fieldwork or sales/marketing experience preferred</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Freshers with a passion for fieldwork and development projects are welcome</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#f5f0ed] p-6 rounded-lg">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Why Join Us?</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Be part of India's digital transformation journey</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Work on impactful government-linked projects</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Performance-based incentives and growth opportunities</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Hands-on experience with cutting-edge digital services</span>
                </li>
              </ul>
            </div>

            <div className="mt-10 text-center">
              <a 
                href="https://forms.gle/mRiX7DJqu7tx4bdh9" 
                className="bg-[#5C4033] hover:bg-[#4a3429] text-white font-bold py-3 px-8 rounded-lg inline-block transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                Apply Now
              </a>
              <p className="mt-4 text-gray-600">Applications will be reviewed on a rolling basis</p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="py-12 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">About Our Company</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">Our Mission</h3>
              <p className="text-gray-700">
                To bridge the digital divide in India by providing affordable, accessible internet and digital services 
                to urban and rural communities through innovative solutions and government partnerships.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">Our Projects</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>PM-WANI Public Wi-Fi Hotspots</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>White-label ATM Services</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>CSP Banking Points</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>GPS Tracking Solutions</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#5C4033] mr-2">•</span>
                  <span>Other Digital India Initiatives</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="py-12 px-4 bg-[#5C4033] text-white text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold mb-4">Ready to Make an Impact?</h2>
          <p className="text-xl mb-8">Join our team and help connect India through innovative digital solutions</p>
          <a 
            href="https://forms.gle/mRiX7DJqu7tx4bdh9" 
            className="bg-white text-[#5C4033] hover:bg-gray-100 font-bold py-3 px-8 rounded-lg inline-block transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apply for Marketing & Project Executive
          </a>
        </div>
      </section>
    </div>
  );
};

export default CareersPage;